import __base_store from '@/store/__base_store'

/**
 * Store de servicios.
 */
export default __base_store({
	state: {
		model_name: 'service',
	},
})

